import React, { ReactElement, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { YandexCaptchaService } from '../../../../infrastructure/utils/captcha/yandex-captcha';

const SMART_CAPTCHA_KEY = 'ysc1_kwvCfFpQyzrSIdZT34wXypL7P4VebhDqjL2RowyG8ea2a483';

interface SmartCaptchaProps {
  containerId?: string;
  onToken: (token: SmartCaptchaToken) => void;
}

const yandexCaptchaService = new YandexCaptchaService();

const SmartCaptcha = function ({
  containerId = 'captcha-container',
  onToken,
}: SmartCaptchaProps): ReactElement {
  const widgetIdRef = useRef<string | null>(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    const renderCaptcha = () => {
      if (!window.smartCaptcha || !document.getElementById(containerId)) return;

      widgetIdRef.current = window.smartCaptcha.render(containerId, {
        sitekey: SMART_CAPTCHA_KEY,
        hl: 'ru',
      });

      window.smartCaptcha.subscribe(widgetIdRef.current, 'success', (token?: string) => {
        onTokenRef.current((token ?? '') as SmartCaptchaToken);
      });
    };

    yandexCaptchaService.loadScript().then(renderCaptcha);

    return () => {
      const widgetId = widgetIdRef.current;
      widgetIdRef.current = null;
      if (window.smartCaptcha?.destroy && widgetId != null) {
        try {
          window.smartCaptcha.destroy(widgetId);
        } catch {
          return;
        }
      }
    };
  }, [containerId]);

  return <Container id={containerId} className="smart-captcha captcha" />;
};

const Container = styled.div``;

export { SmartCaptcha };
